import { Button } from "@blueprintjs/core";
import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { DNDTypes } from './DNDTypes';
import './WindowedApp.css';

class Window extends Component {

	render() {
		//console.log("[Window] render ", this.props);

		const { buttons, connectDragSource, minimized, xLeft, yTop, size_w, size_h, zIndex } = this.props;

		const styles = {
			top: yTop,
			left: xLeft,
			width: size_w,
			height: size_h,
			zIndex: zIndex
		}

		return connectDragSource(
			<div className="Window" style={styles}>
				{!minimized ? this.header() : this.headerClosed()}
				{!minimized ? this.body() : this.bodyClosed()}
				{!minimized && buttons ? this.footer() : this.footerClosed()}
			</div>
		)
	}

	header = () => {
		const { window, funcMinimize, funcMoveZ, funcClose, xLeft, yTop, } = this.props;
		return (
			<div className="WindowHeader" onClick={funcMoveZ} onDoubleClick={funcMinimize}>
				<div className="WindowButtonMove">
					<Button icon="move" />
				</div>
				{window.title} - (x:{xLeft},y:{yTop})
				<div className="WindowButtonMinimize">
					<Button icon="minimize" onClick={funcMinimize} />
				</div>
				<div className="WindowButtonClose">
					<Button icon="cross" onClick={funcClose} />
				</div>
			</div>
		)
	}

	headerClosed = () => {
		const { window, funcMinimize, funcClose, } = this.props;
		return (
			<div className="WindowHeader">
				<div className="WindowButtonMove">
					<Button icon="move" />
				</div>
				{window.title}
				<div className="WindowButtonMinimize">
					<Button icon="maximize" onClick={funcMinimize} />
				</div>
				<div className="WindowButtonClose">
					<Button icon="cross" onClick={funcClose} />
				</div>
			</div>
		)
	}

	body() {
		const { index, fieldData, handleChange, funcMoveZ, } = this.props;
		return (
			<div className={"WindowContent" + " uncollapse"} onDoubleClick={funcMoveZ} onClick={funcMoveZ} >
				{fieldData.map(
					fd =>
						<div key={index + fd}>
							{fd}
							<br />
							<input key={fd} type="text" name="nameField" value={fd} onChange={handleChange} />
							<br />
						</div>
				)}
			</div>
		)
	}

	bodyClosed() {
		const { funcMinimize } = this.props;
		return (
			<div className={"ClickableArea " + " collapse"} onDoubleClick={funcMinimize} > <br /> </div> /* -- NOTE IMPORTANT line break so the element has an area--*/
		)
	}

	footer() {
		const { buttons, funcAction, funcMinimize, actions, } = this.props;
		return (
			<div className="WindowFooter" onDoubleClick={funcMinimize}>
				{buttons.map(
					(bt, index) =>
						<span key={index + bt}>
							<Button onClick={() => funcAction(actions[index])}> {bt} </Button>
						</span>
				)}
			</div>
		)
	}

	footerClosed() {
		const { funcMinimize } = this.props;
		return (
			<div className="WindowFooterClosed" onDoubleClick={funcMinimize} ></div>
		)
	}
}

const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("dragging");
	},
	endDrag: function (props, monitor, component) {
		//console.log("endDrag")
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

Window = DragSource(DNDTypes.WINDOW, dragSource, dragCollect)(Window);
export default Window;


// WEBPACK FOOTER //
// ./src/components/windowed/Window.js